import React from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardHome from "./pages/DashboardHome";
import LeavesPage from "./pages/LeavesPage";
import AdminLeavesPage from "./pages/AdminLeavesPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminTeamsPage from "./pages/AdminTeamsPage";
import LeaveTypesPage from "./pages/LeaveTypesPage";
import AdminHolidaysPage from "./pages/AdminHolidaysPage";
import PasswordHome from "./pages/PasswordHome";
import PrivateRoute from "./components/PrivateRoute";
import DashboardLayout from "./components/DashboardLayout";
import AdminDashboardLayout from "./components/AdminDashboardLayout";
import RoleAwareLayout from "./components/RoleAwareLayout";
import { Navigate } from "react-router-dom";
import AdminTeamLeavesPage from "./pages/AdminTeamLeavesPage";
import AdminMyTeamPage from "./pages/AdminMyTeamPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdminSiteActivitiesPage from "./pages/AdminSiteActivitiesPage";
import AdminToolPermissionsPage from "./pages/AdminToolPermissionsPage";
import VehiclesPage from "./pages/VehiclesPage";
import VehicleDetailPage from "./pages/VehicleDetailPage";
import MyReservationsPage from "./pages/MyReservationsPage";
import AdminVehiclesPage from "./pages/AdminVehiclesPage";
import AdminReservationsPage from "./pages/AdminReservationsPage";
import SATRequestsPage from "./pages/SATRequestsPage";
import SATRequestDetailPage from "./pages/SATRequestDetailPage";
import AdminSATRequestsPage from "./pages/AdminSATRequestsPage";
import AdminApplicationsPage from "./pages/AdminApplicationsPage";
import AdminApplicationTypesPage from "./pages/AdminApplicationTypesPage";
import AdminApplicationTagsPage from "./pages/AdminApplicationTagsPage";
import AdminIntegrationKeysPage from "./pages/AdminIntegrationKeysPage";
import AdminMailSettingsPage from "./pages/AdminMailSettingsPage";
import CCTVPage from "./pages/CCTVPage";

// /admin/vehicles/:id legacy path'inden /vehicles/:id'ye yonlendirir.
const RedirectAdminVehicleDetail = () => {
  const { id } = useParams();
  return <Navigate to={`/vehicles/${id}`} replace />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute
              component={() => (
                <DashboardHome />
              )}
            />
          }
        />

        <Route path="/account" element={<Navigate to="/dashboard" replace />} />
        <Route path="/admin/account" element={<Navigate to="/dashboard" replace />} />
        <Route path="/account/password" element={<Navigate to="/password" replace />} />
        <Route path="/admin/account/password" element={<Navigate to="/password" replace />} />
        <Route
          path="/leave"
          element={
            <PrivateRoute
              userOnly={true}
              component={() => <Navigate to="/leaves" replace />}
            />
          }
        />
        <Route
          path="/my-leaves"
          element={
            <PrivateRoute
              userOnly={true}
              component={() => <Navigate to="/leaves" replace />}
            />
          }
        />

        <Route
          path="/leave-types"
          element={
            <PrivateRoute
              userOnly={true}
              component={() => (
                <DashboardLayout>
                  <LeaveTypesPage />
                </DashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/leaves"
          element={
            <PrivateRoute
              userOnly={true}
              component={() => (
                <DashboardLayout>
                  <LeavesPage />
                </DashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/password"
          element={
            <PrivateRoute
              component={() => (
                <PasswordHome />
              )}
            />
          }
        />

        <Route
          path="/admin/leave"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => <Navigate to="/admin/leaves-me" replace />}
            />
          }
        />

        <Route
          path="/admin/my-leaves"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => <Navigate to="/admin/leaves-me" replace />}
            />
          }
        />

        <Route
          path="/admin/leave-types"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <LeaveTypesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/leaves-me"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <LeavesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/dashboard"
          element={<Navigate to="/dashboard" replace />}
        />
        <Route
          path="/admin/leaves"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminLeavesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/team-leaves"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminTeamLeavesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/my-team"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminMyTeamPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/users"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminUsersPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/teams"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminTeamsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        <Route
          path="/admin/holidays"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminHolidaysPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/settings"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminSettingsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/site-activities"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminSiteActivitiesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/tool-permissions"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminToolPermissionsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/integration-keys"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminIntegrationKeysPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/mail-settings"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminMailSettingsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/password"
          element={<Navigate to="/password" replace />}
        />

        {/* Fleet (vehicle reservations) */}
        {/*
          /vehicles ve /vehicles/:id hem admin hem normal kullanici tarafindan
          erisilebilir; layout rolden bagimsiz olmadigi icin RoleAwareLayout
          kullanilir. /admin/vehicles/:id route'u kaldirildi -- araclara
          herkes /vehicles/:id uzerinden gider, layout icerde secilir.
        */}
        <Route
          path="/vehicles"
          element={
            <PrivateRoute
              component={() => (
                <RoleAwareLayout>
                  <VehiclesPage />
                </RoleAwareLayout>
              )}
            />
          }
        />
        <Route
          path="/vehicles/:id"
          element={
            <PrivateRoute
              component={() => (
                <RoleAwareLayout>
                  <VehicleDetailPage />
                </RoleAwareLayout>
              )}
            />
          }
        />
        <Route
          path="/reservations/my"
          element={
            <PrivateRoute
              component={() => (
                <RoleAwareLayout>
                  <MyReservationsPage />
                </RoleAwareLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/vehicles"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminVehiclesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        {/* /admin/vehicles/:id geriye uyum icin /vehicles/:id'ye yonlendirilir */}
        <Route
          path="/admin/vehicles/:id"
          element={<RedirectAdminVehicleDetail />}
        />
        <Route
          path="/admin/reservations"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminReservationsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/my-reservations"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <RoleAwareLayout>
                  <MyReservationsPage />
                </RoleAwareLayout>
              )}
            />
          }
        />

        {/* SAT (Satin Alma) Talep */}
        <Route
          path="/sat-requests"
          element={
            <PrivateRoute
              component={() => (
                <RoleAwareLayout>
                  <SATRequestsPage />
                </RoleAwareLayout>
              )}
            />
          }
        />
        <Route
          path="/sat-requests/:id"
          element={
            <PrivateRoute
              component={() => (
                <RoleAwareLayout>
                  <SATRequestDetailPage />
                </RoleAwareLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/sat-requests"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminSATRequestsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        {/* İş Başvuruları */}
        <Route
          path="/admin/applications"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminApplicationsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/application-types"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminApplicationTypesPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />
        <Route
          path="/admin/application-tags"
          element={
            <PrivateRoute
              adminOnly={true}
              component={() => (
                <AdminDashboardLayout>
                  <AdminApplicationTagsPage />
                </AdminDashboardLayout>
              )}
            />
          }
        />

        {/* Ofis CCTV — hem admin hem yetkili kullanıcı; layout role göre seçilir.
            Asıl erişim kontrolü backend'de (auth + cctv izni). */}
        <Route
          path="/cctv"
          element={
            <PrivateRoute
              component={() => (
                <RoleAwareLayout>
                  <CCTVPage />
                </RoleAwareLayout>
              )}
            />
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
